import { render, staticRenderFns } from "./WidgetAggregationForm.vue?vue&type=template&id=8f2b087a"
import script from "./WidgetAggregationForm.vue?vue&type=script&lang=js"
export * from "./WidgetAggregationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports